<div class="wifi-header d-flex justify-content-between align-items-center mb-2">
  <div class="d-flex align-items-center gap-2">
    <span class="wifi-title">WiFi Devices</span>
    @if (!isLoading && !isError) {
      <span class="badge online-count-badge">
        {{ getFilteredDevices().length }} Active
      </span>
    }
  </div>
  @if (!isError) {
    <div class="status-indicator d-flex align-items-center gap-2">
      <span class="pulse-dot"></span>
      <span class="status-label text-success">Live</span>
    </div>
  }
</div>

<!-- Search box -->
<div class="search-box-wrapper mb-3">
  <div class="search-input-group">
    <i class="fa fa-search search-icon-btn"></i>
    <input
      id="wifiSearchInput"
      class="wifi-search-input"
      type="text"
      [(ngModel)]="searchQuery"
      placeholder="Filter by IP, MAC, or Vendor..."
      />
      @if (searchQuery) {
        <button class="clear-search-btn" (click)="searchQuery = ''">
          <i class="fa fa-times"></i>
        </button>
      }
    </div>
  </div>

  <!-- Loading state -->
  @if (isLoading && !isError) {
    <div class="wifi-loading text-center py-4">
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="ms-2">Scanning network...</span>
    </div>
  }

  <!-- Error state -->
  @if (isError) {
    <div class="wifi-error text-center p-3 mb-3">
      <i class="fa fa-triangle-exclamation text-warning mb-2" style="font-size: 1.5rem;"></i>
      <div class="error-msg mb-2">Scanner connection offline</div>
      <button class="btn btn-sm btn-outline-danger" (click)="startPolling()">
        <i class="fa fa-redo me-1"></i> Retry
      </button>
    </div>
  }

  <!-- Devices list -->
  @if (!isLoading) {
    <div class="wifi-devices-list custom-scroll">
      @if (getFilteredDevices().length === 0 && !isError) {
        <div class="empty-list text-center py-4">
          <i class="fa fa-wifi text-muted mb-2" style="font-size: 1.5rem;"></i>
          <p class="text-muted m-0">No devices found</p>
        </div>
      }
      <!-- Likely Mobile Section -->
      @if (mobileDevices.length > 0) {
        <div class="category-section mb-3">
          <div class="category-header d-flex justify-content-between align-items-center" (click)="toggleSection('mobile')">
            <div class="d-flex align-items-center gap-2">
              <i class="fa-solid fa-mobile-screen-button category-icon text-mobile"></i>
              <span class="category-title">Likely Mobile</span>
              <span class="badge category-count-badge badge-mobile">
                {{ getFilteredList(mobileDevices).length }}
              </span>
            </div>
            <i class="fa-solid category-chevron" [ngClass]="expandedSections['mobile'] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </div>
          @if (expandedSections['mobile']) {
            <div class="category-content mt-2">
              @for (device of getFilteredList(mobileDevices); track device) {
                <div class="wifi-device-row">
                  <div class="device-avatar" [ngClass]="getVendorTypeClass(device.vendor)">
                    @switch (getVendorType(device.vendor)) {
                      @case ('apple') {
                        <i class="fa-brands fa-apple"></i>
                      }
                      @case ('vivo') {
                        <i class="fa-solid fa-mobile-screen-button"></i>
                      }
                      @case ('samsung') {
                        <i class="fa-solid fa-tablet-screen-button"></i>
                      }
                      @case ('xiaomi') {
                        <i class="fa-solid fa-mobile-button"></i>
                      }
                      @default {
                        <i class="fa-solid fa-network-wired"></i>
                      }
                    }
                  </div>
                  <div class="device-details">
                    <div class="device-ip-row d-flex justify-content-between align-items-center">
                      <span class="device-ip">{{ device.ip }}</span>
                      <span class="badge vendor-pill" [ngClass]="getVendorBadgeClass(device.vendor)">
                        {{ getShortVendor(device.vendor) }}
                      </span>
                    </div>
                    @if (device.mac) {
                      <div class="device-mac-row">
                        <span class="device-mac">{{ device.mac }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- Possible Mobile Section -->
      @if (possibleMobileDevices.length > 0) {
        <div class="category-section mb-3">
          <div class="category-header d-flex justify-content-between align-items-center" (click)="toggleSection('possible')">
            <div class="d-flex align-items-center gap-2">
              <i class="fa-solid fa-laptop-code category-icon text-possible"></i>
              <span class="category-title">Possible Mobile</span>
              <span class="badge category-count-badge badge-possible">
                {{ getFilteredList(possibleMobileDevices).length }}
              </span>
            </div>
            <i class="fa-solid category-chevron" [ngClass]="expandedSections['possible'] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </div>
          @if (expandedSections['possible']) {
            <div class="category-content mt-2">
              @for (device of getFilteredList(possibleMobileDevices); track device) {
                <div class="wifi-device-row">
                  <div class="device-avatar" [ngClass]="getVendorTypeClass(device.vendor)">
                    @switch (getVendorType(device.vendor)) {
                      @case ('apple') {
                        <i class="fa-brands fa-apple"></i>
                      }
                      @case ('vivo') {
                        <i class="fa-solid fa-mobile-screen-button"></i>
                      }
                      @case ('samsung') {
                        <i class="fa-solid fa-tablet-screen-button"></i>
                      }
                      @case ('xiaomi') {
                        <i class="fa-solid fa-mobile-button"></i>
                      }
                      @default {
                        <i class="fa-solid fa-network-wired"></i>
                      }
                    }
                  </div>
                  <div class="device-details">
                    <div class="device-ip-row d-flex justify-content-between align-items-center">
                      <span class="device-ip">{{ device.ip }}</span>
                      <span class="badge vendor-pill" [ngClass]="getVendorBadgeClass(device.vendor)">
                        {{ getShortVendor(device.vendor) }}
                      </span>
                    </div>
                    @if (device.mac) {
                      <div class="device-mac-row">
                        <span class="device-mac">{{ device.mac }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- Private MAC Section -->
      @if (privateMacDevices.length > 0) {
        <div class="category-section mb-3">
          <div class="category-header d-flex justify-content-between align-items-center" (click)="toggleSection('privateMac')">
            <div class="d-flex align-items-center gap-2">
              <i class="fa-solid fa-user-secret category-icon text-private"></i>
              <span class="category-title">Private MAC</span>
              <span class="badge category-count-badge badge-private">
                {{ getFilteredList(privateMacDevices).length }}
              </span>
            </div>
            <i class="fa-solid category-chevron" [ngClass]="expandedSections['privateMac'] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </div>
          @if (expandedSections['privateMac']) {
            <div class="category-content mt-2">
              @for (device of getFilteredList(privateMacDevices); track device) {
                <div class="wifi-device-row">
                  <div class="device-avatar" [ngClass]="getVendorTypeClass(device.vendor)">
                    @switch (getVendorType(device.vendor)) {
                      @case ('apple') {
                        <i class="fa-brands fa-apple"></i>
                      }
                      @case ('vivo') {
                        <i class="fa-solid fa-mobile-screen-button"></i>
                      }
                      @case ('samsung') {
                        <i class="fa-solid fa-tablet-screen-button"></i>
                      }
                      @case ('xiaomi') {
                        <i class="fa-solid fa-mobile-button"></i>
                      }
                      @default {
                        <i class="fa-solid fa-network-wired"></i>
                      }
                    }
                  </div>
                  <div class="device-details">
                    <div class="device-ip-row d-flex justify-content-between align-items-center">
                      <span class="device-ip">{{ device.ip }}</span>
                      <span class="badge vendor-pill" [ngClass]="getVendorBadgeClass(device.vendor)">
                        {{ getShortVendor(device.vendor) }}
                      </span>
                    </div>
                    @if (device.mac) {
                      <div class="device-mac-row">
                        <span class="device-mac">{{ device.mac }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- Unknown Vendor Section -->
      @if (unknownVendorDevices.length > 0) {
        <div class="category-section mb-3">
          <div class="category-header d-flex justify-content-between align-items-center" (click)="toggleSection('unknown')">
            <div class="d-flex align-items-center gap-2">
              <i class="fa-solid fa-circle-question category-icon text-unknown"></i>
              <span class="category-title">Unknown Vendor</span>
              <span class="badge category-count-badge badge-unknown">
                {{ getFilteredList(unknownVendorDevices).length }}
              </span>
            </div>
            <i class="fa-solid category-chevron" [ngClass]="expandedSections['unknown'] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </div>
          @if (expandedSections['unknown']) {
            <div class="category-content mt-2">
              @for (device of getFilteredList(unknownVendorDevices); track device) {
                <div class="wifi-device-row">
                  <div class="device-avatar" [ngClass]="getVendorTypeClass(device.vendor)">
                    @switch (getVendorType(device.vendor)) {
                      @case ('apple') {
                        <i class="fa-brands fa-apple"></i>
                      }
                      @case ('vivo') {
                        <i class="fa-solid fa-mobile-screen-button"></i>
                      }
                      @case ('samsung') {
                        <i class="fa-solid fa-tablet-screen-button"></i>
                      }
                      @case ('xiaomi') {
                        <i class="fa-solid fa-mobile-button"></i>
                      }
                      @default {
                        <i class="fa-solid fa-network-wired"></i>
                      }
                    }
                  </div>
                  <div class="device-details">
                    <div class="device-ip-row d-flex justify-content-between align-items-center">
                      <span class="device-ip">{{ device.ip }}</span>
                      <span class="badge vendor-pill" [ngClass]="getVendorBadgeClass(device.vendor)">
                        {{ getShortVendor(device.vendor) }}
                      </span>
                    </div>
                    @if (device.mac) {
                      <div class="device-mac-row">
                        <span class="device-mac">{{ device.mac }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
